import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  kycCustomers: {
    list: {
      error: 'There is a problem retrieving the customers',
    },
    create: {
      error: 'There is a problem creating the customer',
      success: 'Customer created successfully',
    },
    retrieve: {
      error: 'There is a problem retrieving the customer details',
    },
    update: {
      error: 'There is a problem updating the customer',
      success: 'Customer updated successfully',
    },
    approve: {
      error: 'There is a problem approving the selected customers',
      success: 'Customers approved successfully',
    },
    delete: {
      success: 'Customer deleted successfully',
      error: 'There is a problem deleting the customer',
    },
  },
}
